import { render, staticRenderFns } from "./v_Terms_CreatorPolicy.vue?vue&type=template&id=4f4a38e9&scoped=true&"
import script from "./v_Terms_CreatorPolicy.vue?vue&type=script&lang=js&"
export * from "./v_Terms_CreatorPolicy.vue?vue&type=script&lang=js&"
import style0 from "./v_Terms_CreatorPolicy.vue?vue&type=style&index=0&id=4f4a38e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4a38e9",
  null
  
)

export default component.exports